export default __webpack_public_path__ + "static/media/pic4.085f7c98.png";